import {
    Box,
    FormControl,
    FormControlLabel,
    Grid,
    MenuItem,
    Select,
    Switch,
    Typography,
    useTheme,
} from '@mui/material';
import RuleIcon from '@mui/icons-material/Rule';
import DoneIcon from '@mui/icons-material/Done';
import { useAuth } from '../../../../hooks/useAuth';
import useAccountImport from './hooks/AccountImport.hooks';
import { useState } from 'react';
import React from 'react';

const AccountImportFieldMapping = () => {
    const { user } = useAuth();
    const { fileError, unmappedColumns, mapSchema, manualMapField, allColumns, hasUnmapped, hasError, loaded } =
        useAccountImport();
    const [showAll, setShowAll] = useState(false);
    const [unmappedColumnError, setUnmappedColumnError] = useState(false);
    const missingSchemaFields = mapSchema.filter((s) => !s.mappedField || showAll);
    const columnsToMap = showAll ? allColumns : unmappedColumns;

    const theme = useTheme();

    console.log(mapSchema);

    return (
        <>
            {loaded && !fileError && (
                <Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                            {hasUnmapped && <RuleIcon sx={{ color: theme.palette.error.main }} />}
                            {!hasUnmapped && <DoneIcon sx={{ color: theme.palette.success.main }} />}
                            <Typography variant="subtitle1" sx={{ mb: 2, mt: 2, ml: 2 }}>
                                {hasUnmapped ? 'Unmapped Columns' : 'All Columns Mapped'}
                            </Typography>
                        </Box>

                        <FormControlLabel
                            control={<Switch checked={showAll} onChange={() => setShowAll(!showAll)} />}
                            label="All"
                        />
                    </Box>

                    {!hasError && (
                        <Grid container rowGap={2}>
                            {missingSchemaFields.map((schemaCol, index) => (
                                <React.Fragment key={`map-${index}`}>
                                    <Grid xs={6}>
                                        {schemaCol.displayName} {schemaCol.required ? '(required)' : '(optional)'}
                                    </Grid>
                                    <Grid xs={6}>
                                        <FormControl fullWidth size="small">
                                            <Select
                                                value={schemaCol.mappedField ?? ''}
                                                onChange={(e) =>
                                                    manualMapField(e.target.value as string, schemaCol.columnName)
                                                }
                                            >
                                                {columnsToMap.map((f) => (
                                                    <MenuItem key={`map-${index}-${f}`} value={f}>
                                                        {f}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </React.Fragment>
                            ))}
                        </Grid>
                    )}
                </Box>
            )}
        </>
    );
};

export default AccountImportFieldMapping;
